/**
 * Rôles tels que définis dans le catalogue AuthCentral du CRM Lanala.
 * Correspondent aux valeurs du claim `roles` dans le JWT (sans le préfixe ROLE_).
 */
export enum UserRole {
  TELECONSEILLER = 'TELECONSEILLER',
  SUPERVISEUR = 'SUPERVISEUR',
  BACK_OFFICE = 'BACK_OFFICE',
  ADMIN = 'ADMIN',
}

/**
 * Représentation du CurrentUser telle que renvoyée par l'API dans LoginResponse.user.
 * Décodée directement à partir des claims JWT par le serveur — aucun appel secondaire nécessaire.
 */
export interface User {
  /** UUID de l'utilisateur (claim `sub`) */
  id: string;
  /** Email de l'utilisateur */
  email: string;
  /** Prénom (claim `given_name`) */
  givenName: string;
  /** Nom de famille (claim `family_name`) */
  familyName: string;
  /** UUID de l'application cible */
  applicationId: string;
  /** UUID de la filiale de rattachement — null si non rattaché */
  filialeId: string | null;
  /** UUID du superviseur hiérarchique — null si non défini */
  superviseurId: string | null;
  /** Permissions effectives de l'utilisateur */
  permissions: string[];
  /** Rôles de l'utilisateur */
  roles: string[];
}

/** Nom d'affichage complet de l'utilisateur */
export function getUserDisplayName(user: User): string {
  return `${user.givenName} ${user.familyName}`.trim();
}

/** Vérifie si l'utilisateur possède un rôle donné */
export function hasRole(user: User, role: UserRole): boolean {
  return user.roles.includes(role);
}
